module.exports = __webpack_public_path__ + "static/media/YF85_01.e8c765f2.jpg";